<template>
    <div v-if="order.deadline_at" class="badge d-flex flex-column justify-content-center" :class="[badgeType]" style="transition: background-color .3s ease-out;">
        <div class="d-flex flex-row justify-content-center text-white">
            <div v-if="$slots.default" class="pr-1 d-flex flex-column justify-content-center">
                <slot/>
            </div>
            <div v-if="diffInSeconds > 0" class="text-monospace" v-html="humanReadableDifference"/>
            <div v-else>
                <i class="fas fa-exclamation-triangle mr-1"/>
                {{ __('general.thing_expired', {thing: __('general.time')}) }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        order: Object,
    },

    data() {
        return {
            deadline: new Date(this.order.deadline_at),
            diffInSeconds: 0,
        };
    },

    mounted() {
        if (this.order.deadline_at) {
            this.updateDifference();
            setInterval(this.updateDifference, 1000);
        }
    },

    methods: {
        updateDifference() {
            this.diffInSeconds = Math.max(0, Math.floor((this.deadline - new Date()) / 1000));
        },

        twoDigits(number) {
            if (number < 10) {
                return '0' + number;
            }

            return number;
        },
    },

    computed: {
        diffInMinutes() {
            return Math.floor(this.diffInSeconds / 60);
        },

        humanReadableDifference() {
            if (this.diffInMinutes > 0) {
                let secondsRemaining = this.diffInSeconds - this.diffInMinutes * 60;

                return `${this.twoDigits(this.diffInMinutes)}<small>min</small> ${this.twoDigits(
                    secondsRemaining)}<small>s</small>`;
            }

            return `${this.twoDigits(this.diffInSeconds)}<small>s</small>`;
        },

        badgeType() {
            if (this.diffInMinutes > 45) return 'badge-success';
            if (this.diffInMinutes > 15) return 'badge-warning';
            return 'badge-danger';
        },
    },
};
</script>
